import React, { useCallback, useMemo } from 'react';
import { Activity } from '../../models/activity';
import { AppCard } from '../app/appCard';
import { useActivitiesContext } from '../../context/activities';
import { generateProjectLabel } from '../../services/projectService';

interface Props {
  activity: Activity;
  onDeleteActivity(activity: Activity): void;
  onEditActivity(activity: Activity): void;
}

enum TaskStatus {
  Finished = 'Finished',
}

export function ActivityDayTask({
  activity,
  onDeleteActivity,
  onEditActivity,
}: Props): JSX.Element {
  const { showEmployeeName, isActivitiesReadOnly } = useActivitiesContext();

  const handleDelete = useCallback(() => {
    onDeleteActivity(activity);
  }, [activity, onDeleteActivity]);

  const handleEdit = useCallback(() => {
    onEditActivity(activity);
  }, [activity, onEditActivity]);

  const isTaskFinished = useMemo(
    () => activity.task.status === TaskStatus.Finished,
    [activity.task.status]
  );

  return (
    <AppCard
      title={activity.task.name}
      statusInfo={`${activity.hours}h`}
      subTitle={
        showEmployeeName
          ? `${activity.employee.name}`
          : generateProjectLabel(
              activity.task.project.name,
              activity.task.project.code
            )
      }
      details={[activity.comment]}
      buttons={
        isActivitiesReadOnly
          ? []
          : [
              {
                label: 'Delete',
                onClick: handleDelete,
                isPrimary: false,
                disabled: isTaskFinished,
              },
              {
                label: 'Edit',
                onClick: handleEdit,
                isPrimary: true,
                disabled: isTaskFinished,
              },
            ]
      }
    />
  );
}
